/**
 * @generated SignedSource<<ca48d1349218851c934317e1c4da742a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ProductProviderInput = {
  productEcommerce?: ProductProviderEcommerceInputDtoInput | null;
  productID?: string | null;
  retailProfitPercentage: number;
  selectedOptions?: ReadonlyArray<ProductProviderOptionInputDtoInput | null> | null;
  sides?: ReadonlyArray<string | null> | null;
  variantIDs?: ReadonlyArray<number> | null;
  verticalRotation: boolean;
};
export type ProductProviderEcommerceInputDtoInput = {
  productDescription?: string | null;
  productTitle?: string | null;
};
export type ProductProviderOptionInputDtoInput = {
  id?: string | null;
  value?: string | null;
};
export type importConfigurationMutation$variables = {
  input: ProductProviderInput;
  provider: ProductProvider;
};
export type importConfigurationMutation$data = {
  readonly importProviderProduct: {
    readonly taskID: number;
  };
};
export type importConfigurationMutation = {
  response: importConfigurationMutation$data;
  variables: importConfigurationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provider"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      }
    ],
    "concreteType": "ProductProviderOutput",
    "kind": "LinkedField",
    "name": "importProviderProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "importConfigurationMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "importConfigurationMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c43e3b06f5d689cde4a0c20dd236c32b",
    "id": null,
    "metadata": {},
    "name": "importConfigurationMutation",
    "operationKind": "mutation",
    "text": "mutation importConfigurationMutation(\n  $input: ProductProviderInput!\n  $provider: ProductProvider!\n) {\n  importProviderProduct(input: $input, provider: $provider) {\n    taskID\n  }\n}\n"
  }
};
})();

(node as any).hash = "d250715322b9d41da4783f2b57bb7d1d";

export default node;
